(() => {
  'use strict';
  /* ---------- Kategorije na početnoj (tabovi) ---------- */
  const tabsIn = section => [...section.querySelectorAll('[data-ns-product-filter]')];
  const panelFor = (section, tab) => [...section.querySelectorAll('[data-ns-product-panel]')].find(panel => panel.dataset.nsProductPanel === tab.dataset.nsProductFilter);
  function selectTab(section, tab, announce = true) {
    const panel = panelFor(section, tab);
    if (!panel) return false;
    for (const button of tabsIn(section)) {
      const selected = button === tab;
      button.classList.toggle('active', selected);
      button.setAttribute('aria-selected', String(selected));
      button.tabIndex = selected ? 0 : -1;
    }
    for (const item of section.querySelectorAll('[data-ns-product-panel]')) item.hidden = item !== panel;
    const link = section.querySelector('[data-ns-collection-link]');
    if (link) link.href = tab.href;
    const status = section.querySelector('[data-ns-tab-status]');
    if (status && announce) status.textContent = tab.textContent.trim() + ': ' + (panel.querySelectorAll('.product-card').length ? 'proizvodi su prikazani.' : 'Trenutno nema proizvoda.');
    return true;
  }
  function initTabs() {
    for (const section of document.querySelectorAll('[data-ns-product-tabs]')) {
      const tabs = tabsIn(section);
      if (!tabs.length) continue;
      section.querySelector('[data-ns-tab-list]')?.setAttribute('role', 'tablist');
      for (const tab of tabs) tab.setAttribute('role', 'tab');
      for (const panel of section.querySelectorAll('[data-ns-product-panel]')) {
        panel.setAttribute('role', 'tabpanel');
        panel.tabIndex = 0;
      }
      selectTab(section, tabs.find(tab => tab.classList.contains('active')) || tabs[0], false);
    }
  }
  document.addEventListener('click', event => {
    const tab = event.target.closest('[data-ns-product-filter]');
    if (!tab || event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const section = tab.closest('[data-ns-product-tabs]');
    if (section && selectTab(section, tab)) event.preventDefault();
  });
  document.addEventListener('keydown', event => {
    const tab = event.target.closest('[data-ns-product-filter]');
    if (!tab) return;
    const section = tab.closest('[data-ns-product-tabs]');
    if (!section) return;
    const tabs = tabsIn(section), index = tabs.indexOf(tab);
    let next;
    if (event.key === 'ArrowRight') next = tabs[(index + 1) % tabs.length];
    if (event.key === 'ArrowLeft') next = tabs[(index - 1 + tabs.length) % tabs.length];
    if (event.key === 'Home') next = tabs[0];
    if (event.key === 'End') next = tabs[tabs.length - 1];
    if (event.key === ' ') next = tab;
    if (next && selectTab(section, next)) {
      event.preventDefault();
      next.focus();
      next.scrollIntoView?.({block: 'nearest', inline: 'nearest'});
    }
  });

  /* ---------- Filteri u kolekciji bez ponovnog učitavanja stranice ---------- */
  const collectionRoot = () => document.querySelector('[data-ns-collection]');
  let controller;
  function setBusy(root, busy) {
    root.classList.toggle('is-loading', busy);
    root.querySelector('[data-ns-results]')?.setAttribute('aria-busy', String(busy));
  }
  function buildUrl(form) {
    const params = new URLSearchParams();
    for (const [key, value] of new FormData(form)) if (value !== '') params.append(key, value);
    const action = (form.getAttribute('action') || location.pathname).split('?')[0];
    const query = params.toString();
    return query ? action + '?' + query : action;
  }
  async function loadCollection(url, {push = true, focusName = null, focusValue = null, scroll = false} = {}) {
    const root = collectionRoot();
    if (!root || !root.dataset.sectionId) return false;
    controller?.abort();
    controller = new AbortController();
    const fetchUrl = new URL(url, location.origin);
    fetchUrl.searchParams.set('section_id', root.dataset.sectionId);
    setBusy(root, true);
    try {
      const response = await fetch(fetchUrl.href, {signal: controller.signal, headers: {Accept: 'text/html'}});
      if (!response.ok) throw new Error(String(response.status));
      const doc = new DOMParser().parseFromString(await response.text(), 'text/html');
      for (const selector of ['[data-ns-facets]', '[data-ns-results]', '[data-ns-results-count]']) {
        const fresh = doc.querySelector(selector), current = root.querySelector(selector);
        if (fresh && current) current.replaceWith(fresh);
      }
      if (push) {
        const clean = new URL(url, location.origin);
        clean.searchParams.delete('section_id');
        history.pushState({nsCollection: true}, '', clean.href);
      }
      if (focusName) {
        const input = root.querySelector(`[data-ns-facets] [name="${CSS.escape(focusName)}"][value="${CSS.escape(focusValue ?? '')}"]`) || root.querySelector(`[data-ns-facets] [name="${CSS.escape(focusName)}"]`);
        input?.focus({preventScroll: true});
      }
      if (scroll) root.querySelector('[data-ns-results]')?.scrollIntoView({block: 'start', behavior: 'smooth'});
      const status = root.querySelector('[data-ns-results-count]');
      if (status) status.setAttribute('aria-live', 'polite');
      document.dispatchEvent(new CustomEvent('ns:collection-updated'));
      return true;
    } catch (error) {
      return error.name === 'AbortError';
    } finally {
      setBusy(root, false);
    }
  }
  document.addEventListener('change', async event => {
    const input = event.target, form = input.closest('.ns-facet-form');
    if (!form || !(input.matches('select[name="sort_by"]') || input.matches('input[type="checkbox"],input[type="radio"]'))) return;
    if (collectionRoot()?.dataset.sectionId) {
      const ok = await loadCollection(buildUrl(form), {focusName: input.name, focusValue: input.value});
      if (ok) return;
    }
    if (form.requestSubmit) form.requestSubmit();
    else form.querySelector('button[type="submit"]')?.click();
  });
  document.addEventListener('submit', async event => {
    const form = event.target;
    if (!form.matches('.ns-facet-form') || event.defaultPrevented || !collectionRoot()?.dataset.sectionId) return;
    event.preventDefault();
    const ok = await loadCollection(buildUrl(form));
    if (!ok) form.submit();
  });
  document.addEventListener('click', async event => {
    const link = event.target.closest('a');
    const root = collectionRoot();
    if (!link || !root || !root.dataset.sectionId || !root.contains(link)) return;
    if (!(link.closest('.ns-active-filters') || link.closest('.ns-pagination') || link.matches('.ns-reset') || link.closest('.ns-empty'))) return;
    if (event.button > 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    const url = new URL(link.href, location.origin);
    if (url.origin !== location.origin) return;
    event.preventDefault();
    const ok = await loadCollection(url.href, {scroll: Boolean(link.closest('.ns-pagination'))});
    if (!ok) location.assign(link.href);
  });
  window.addEventListener('popstate', event => {
    if (collectionRoot()?.dataset.sectionId && (event.state?.nsCollection || location.search)) loadCollection(location.href, {push: false});
  });

  /* ---------- Skraćeni opis kolekcije ---------- */
  document.addEventListener('click', event => {
    const toggle = event.target.closest('[data-ns-clamp-toggle]');
    if (!toggle) return;
    const clamp = toggle.parentElement?.querySelector('[data-ns-clamp]');
    if (!clamp) return;
    const expanded = clamp.classList.toggle('expanded');
    toggle.setAttribute('aria-expanded', String(expanded));
    toggle.textContent = expanded ? 'Prikaži manje' : 'Prikaži više';
  });
  function initClamp() {
    for (const clamp of document.querySelectorAll('[data-ns-clamp]')) {
      const toggle = clamp.parentElement?.querySelector('[data-ns-clamp-toggle]');
      if (toggle) toggle.hidden = clamp.scrollHeight <= clamp.clientHeight + 2;
    }
  }
  document.addEventListener('shopify:section:load', () => { initTabs(); initClamp(); });
  window.addEventListener('load', initClamp);
  initTabs();
  initClamp();
})();
